import React, { useState } from 'react';
import { X } from 'lucide-react';

const StockCheckModal = ({ order, onClose, onSubmit }) => {
    const [itemStatuses, setItemStatuses] = useState(
        order.items.map(item => ({ ...item, available: item.quantity, status: 'available' }))
    );
    const [notes, setNotes] = useState('');

    const updateItem = (idx, field, value) => {
        const updated = [...itemStatuses];
        updated[idx][field] = value;
        if (field === 'available') {
            const parsedVal = parseFloat(value);
            const valNum = isNaN(parsedVal) ? 0 : parsedVal;
            updated[idx].status = valNum >= updated[idx].quantity ? 'available' : 'partial';
        }
        setItemStatuses(updated);
    };

    const handleSubmit = () => {
        const allAvailable = itemStatuses.every(item => (parseFloat(item.available) || 0) >= item.quantity);
        const status = allAvailable ? 'stock_confirmed' : 'partially_available';
        const formattedItems = itemStatuses.map(item => ({ available: Math.max(0, parseFloat(item.available) || 0) }));
        onSubmit(order.id, status, formattedItems, notes);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full">
                <div className="border-b p-4 flex items-center justify-between">
                    <h2 className="text-2xl font-bold">Stock Check - {order.id}</h2>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded">
                        <X size={24} />
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div className="bg-blue-50 p-4 rounded">
                        <p className="font-semibold">Customer: {order.customer.name}</p>
                        <p className="text-sm text-gray-600">Salesman: {order.salesman}</p>
                    </div>

                    <div className="space-y-3">
                        {itemStatuses.map((item, idx) => (
                            <div key={item.id} className="border rounded p-4">
                                <div className="flex items-center justify-between mb-2">
                                    <div>
                                        <p className="font-bold">{item.product}</p>
                                        <p className="text-sm text-gray-600">Requested: {item.quantity} {item.unit}</p>
                                    </div>
                                </div>
                                <div className="flex gap-3 items-center">
                                    <label className="flex-1">
                                        <span className="text-sm text-gray-600 block mb-1">Available Quantity</span>
                                        <input
                                            type="number"
                                            value={item.available}
                                            onChange={(e) => updateItem(idx, 'available', e.target.value)}
                                            className="w-full p-2 border rounded"
                                            min="0"
                                            step="0.01"
                                        />
                                    </label>
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => updateItem(idx, 'available', item.quantity)}
                                            className={`px-3 py-2 rounded ${item.status === 'available' ? 'bg-green-500 text-white' : 'bg-gray-200'}`}
                                        >
                                            ✓ Full
                                        </button>
                                        <button
                                            onClick={() => updateItem(idx, 'available', 0)}
                                            className={`px-3 py-2 rounded ${item.available === 0 ? 'bg-red-500 text-white' : 'bg-gray-200'}`}
                                        >
                                            ✗ None
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Add notes about stock status..."
                        className="w-full p-3 border rounded h-24"
                    />

                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSubmit}
                            className="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Submit Stock Check
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StockCheckModal;
